import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import find from 'lodash/find';
import gql from 'graphql-tag';
import SMHoursTable from '../SMHoursTable';

import styles from './styles.scss';

const propTypes = {
  facility: PropTypes.shape({
    hours: PropTypes.shape().isRequired,
  }).isRequired,
};

const defaultProps = {};

const Hours = ({
  facility,
}) => {
  const {
    hours: {
      office: {
        hours: officeHours,
      },
    },
  } = facility;

  const todaysHours = find(officeHours, { day: new Date().toLocaleString('en-us', { weekday: 'long' }) });

  return (
    <div className={cx(styles.hoursContainer, 'clearfix')}>
      <SMHoursTable hours={[todaysHours]} onlyToday />
    </div>
  );
};

Hours.propTypes = propTypes;
Hours.defaultProps = defaultProps;

Hours.fragments = {
  facility: gql`
    fragment HoursFacility on Facility {
      hours {
        office {
          hours {
            day
            open
            close
          }
        }
      }
    }
  `,
};

export default Hours;
